import { useState } from 'react';
import { ExportUIData } from '@/Shared';


export interface ExportUIHook {
    exportUIData?: ExportUIData | null,
    openExport: (data: ExportUIData, onClose? : () => void) => void,
    closeExport: () => void,
}
export function useExportUI(): ExportUIHook {
    const [exportUIData, setExportUIData] = useState<ExportUIData | null>();
    const [onClose, setOnClose] = useState<() => void>();

    const openExport = (data: ExportUIData, onClose? : () => void) => {
        setExportUIData(data);
        setOnClose(onClose);
    }

    const closeExport = () => {
        setExportUIData(null);
        onClose?.();
    }

    return {
        exportUIData,
        openExport,
        closeExport,
    };
}
